import type { SVGProps } from 'react';
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <g clipPath="url(#send_svg__a)">
      <path
        fill="currentColor"
        fillOpacity={0.45}
        d="M17.426 8.74.622.315a.323.323 0 0 0-.419.121.32.32 0 0 0-.037.242l1.731 7.076a.32.32 0 0 0 .21.227l2.966 1.018-2.965 1.019a.31.31 0 0 0-.207.227L.166 17.33a.323.323 0 0 0 .456.364l16.804-8.377a.33.33 0 0 0 .145-.143.326.326 0 0 0-.145-.434m-15.28 6.577 1.01-4.13 5.931-2.035a.161.161 0 0 0 0-.305l-5.93-2.033L2.15 2.699l12.617 6.326z"
      />
    </g>
    <defs>
      <clipPath id="send_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSend;
